// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebarLtMd {
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: #f1f1f1;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  animation: slide-in 0.5s forwards;
  -webkit-animation: slide-in 0.5s forwards;
}

.sidebar {
  margin: 0;
  padding: 0;
  width: 300px;
  display:flex !important;
  background-color: #f1f1f1;
  position: fixed;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
}
.contentLtMd {
  width: 100%;
  overflow-x: hidden;
}
.content {
  margin-left: 300px;
  width: 100%;
  display:flex !important;
  padding: 1px 16px;
  overflow-x: hidden;
}

.notSetYet {
  display: none;
}


#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(-100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

mat-expansion-panel {
  margin: 0;
}

.wrapper {
  margin-left: 1em;
  margin-right: 1em;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 1em;
  grid-column-gap: 1em;
}

.iconFont {
  font-size: 50px;
}
a {
  color: black;
  text-decoration: none; /* no underline */
}

.buttonGtSm {
  width: 300px;
  height:300px;
}

.wrapperGtSm {
  width: 300px;
  height:250px;
}

.buttonLtMd {
  width: 100%;
}

.databaseInfoFont {
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/app/repository/repository.component.css"],"names":[],"mappings":";AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;EACnC;AACF;;AAWA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;EACxB,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,qBAAqB,EAAE,iBAAiB;AAC1C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB","sourcesContent":["\n.sidebarLtMd {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  background-color: #f1f1f1;\n  height: 100%;\n  overflow: auto;\n  overflow-x: hidden;\n  animation: slide-in 0.5s forwards;\n  -webkit-animation: slide-in 0.5s forwards;\n}\n\n.sidebar {\n  margin: 0;\n  padding: 0;\n  width: 300px;\n  display:flex !important;\n  background-color: #f1f1f1;\n  position: fixed;\n  height: 100%;\n  overflow: auto;\n  overflow-x: hidden;\n}\n.contentLtMd {\n  width: 100%;\n  overflow-x: hidden;\n}\n.content {\n  margin-left: 300px;\n  width: 100%;\n  display:flex !important;\n  padding: 1px 16px;\n  overflow-x: hidden;\n}\n\n.notSetYet {\n  display: none;\n}\n\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n@keyframes slide-in {\n  0% {\n    -webkit-transform: translateX(-100%);\n  }\n  100% {\n    -webkit-transform: translateX(0%);\n  }\n}\n\n@-webkit-keyframes slide-in {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n\nmat-expansion-panel {\n  margin: 0;\n}\n\n.wrapper {\n  margin-left: 1em;\n  margin-right: 1em;\n  display: grid;\n  grid-template-rows: auto;\n  grid-template-columns: repeat(4, 1fr);\n  grid-row-gap: 1em;\n  grid-column-gap: 1em;\n}\n\n.iconFont {\n  font-size: 50px;\n}\na {\n  color: black;\n  text-decoration: none; /* no underline */\n}\n\n.buttonGtSm {\n  width: 300px;\n  height:300px;\n}\n\n.wrapperGtSm {\n  width: 300px;\n  height:250px;\n}\n\n.buttonLtMd {\n  width: 100%;\n}\n\n.databaseInfoFont {\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
